// extracted by mini-css-extract-plugin
module.exports = {"container":"edu-fair_container__3hojV","mainText":"edu-fair_mainText__20Kt7","live":"edu-fair_live__ixU_j"};